/**
 * Utility function to play a notification sound when a new message arrives
 * Uses HTML5 Audio API with preview.mp3 file
 */

export const playNotificationSound = () => {
  const audio = new Audio('/assets/sound/preview.mp3');
  audio.play();
};

